// extracted by mini-css-extract-plugin
module.exports = {"container":"notFound_container__CIKq7","title":"notFound_title__59GqZ"};